module.exports = __webpack_public_path__ + "img/2-Vogel.4383ad52.png";